/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * INosTextBlock contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum alignment {
    left = 'left',
    right = 'right',
    center = 'center'
}

export const enum fontsize {
    small = 'small',
    medium = 'medium',
    large = 'large',
    extralarge = 'extralarge'
}

export const enum layout {
    row = 'row',
    column = 'column'
}

export const enum theme {
    corporate = 'corporate',
    tecdoc = 'tecdoc',
    teccom = 'teccom'
}

export interface INosTextBlockConfig extends Msdyn365.IModuleConfig {
    paragraph?: Msdyn365.RichText;
    pictogram?: string;
    links?: ILinksData[];
    alignment?: alignment;
    fontsize?: fontsize;
    className?: string;
    clientRender?: boolean;
    layout?: layout;
    theme?: theme;
}

export const enum LinksButtonType {
    primaryDark = 'primaryDark',
    primaryLight = 'primaryLight',
    secondaryDark = 'secondaryDark',
    secondaryLight = 'secondaryLight'
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    buttonType?: LinksButtonType;
}

export interface INosTextBlockProps<T> extends Msdyn365.IModule<T> {
    config: INosTextBlockConfig;
}
